/*
 * Copyright (c) Nexign, JSC, 2019.
 */

/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.1.0
 * @since 1.1.0
 */

import { IGTMOperation } from './index';

export const onClickSubscriberLinkWidgetSubscriberMaxCosts = (subscriber: string): IGTMOperation => ({
    'event': 'addEvents_makeActions',
    'event_id': 'd-v217-e18',
    'event_cat': 'Абоненты с наибольшими расходами',
    'event_name': 'clickElement',
    'event_param': subscriber,
});
